import { z } from "zod";

import { ShopifyShippingRateDtoSchema } from "../../../dtos/shipping-rates";

export const GetShippingRatesRequestBodySchema = z.object({
  rate: ShopifyShippingRateDtoSchema,
});

export type GetShippingRatesRequestBodyType = z.infer<
  typeof GetShippingRatesRequestBodySchema
>;

export const ShippingRatesResponse = z.object({
  service_name: z.string().nullish(),
  description: z.string().nullish(),
  service_code: z.string().nullish(),
  currency: z.string().nullish(),

  // total_price must be in subunits.
  // If the currency does not use subunits, the value must be multiplied by 100.
  //  For example: `"total_price": 500` for 5.00 CAD, `"total_price": 100000` for 1000 JPY.

  total_price: z.number(),
  phone_required: z.boolean().nullish(),
  min_delivery_date: z.string().nullish(),
  max_delivery_date: z.string().nullish(),
});

export type ShippingRatesResponseType = z.infer<typeof ShippingRatesResponse>;

export const GetShippingRatesResponseBodySchema = z.object({
  rates: ShippingRatesResponse.array(),
});

export type GetShippingRatesResponseBodyType = z.infer<
  typeof GetShippingRatesResponseBodySchema
>;
